"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexBox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lib_1 = require("../../lib");
const FlexBox = ({ children, className, column, justifyContent, alignItems, flex, flexBasis, onClick, wrap, style }) => {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.classnames)(className, (0, lib_1.bem)('flex', (0, lib_1.use)(flex, `__flex--${flex}`), (0, lib_1.use)(column, '__flex-direction--column'), (0, lib_1.use)(justifyContent, `__justify-content--${justifyContent}`), (0, lib_1.use)(alignItems, `__align-items--${alignItems}`), (0, lib_1.use)(wrap, '__wrap'))), onClick: onClick, style: Object.assign({ flexBasis }, style) }, { children: children }), void 0));
};
exports.FlexBox = FlexBox;
//# sourceMappingURL=FlexBox.js.map